
import React, { useState } from 'react';
import { Button, Card, Row, Col, Form } from 'react-bootstrap';
import { RiCheckLine } from 'react-icons/ri';
import axios from 'axios';

const NuevoReporte = ({ onVolver }) => {
    const [paso, setPaso] = useState(1);
    const [frecuencia, setFrecuencia] = useState('Diaria');
    const [diasSeleccionados, setDiasSeleccionados] = useState([]);
    const [horaEnvio, setHoraEnvio] = useState('00:00');
    const [diaMensual, setDiaMensual] = useState(1);
    const [nombreReporte, setNombreReporte] = useState('');
    const [instrucciones, setInstrucciones] = useState('');

    
    const diasSemana = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];

    const toggleDia = (dia) => {
        setDiasSeleccionados(prev =>
            prev.includes(dia) ? prev.filter(d => d !== dia) : [...prev, dia]
        );
    };

    //   Configuracion de envio

    const renderPaso1 = () => (
        <>
            <h5 className='section-subtitle'>Configuración de envío</h5>
            <p className='section-description'>Selecciona la frecuencia del reporte a enviar: diaria, semanal o mensual.</p>

            <div className="mb-4 d-flex gap-2">
                {['Diaria', 'Semanal', 'Mensual'].map(opcion => (
                    <Button
                        key={opcion}
                        variant={frecuencia === opcion ? 'primary' : 'outline-primary'}
                        onClick={() => setFrecuencia(opcion)}
                    >
                        {opcion}
                    </Button>
                ))}
            </div>

            <Row>
                <Col md={6}>
                    <Card body>
                        <Form.Label>{frecuencia}</Form.Label>
                        <div className="d-flex flex-wrap gap-2">
                            {frecuencia === 'Mensual' ? (
                                <Form.Group controlId="diaMensual">
                                    <Form.Label>Día</Form.Label>
                                    <Form.Control
                                        type="number"
                                        min={1}
                                        max={31}
                                        value={diaMensual}
                                        onChange={(e) => setDiaMensual(Number(e.target.value))}
                                    />
                                    <Form.Text>Si se elige un día inexistente, se usará el último del mes.</Form.Text>
                                </Form.Group>
                            ) : (
                                diasSemana.map(dia => (
                                    <Form.Check
                                        key={dia}
                                        inline
                                        label={dia}
                                        type={frecuencia === 'Diaria' ? 'checkbox' : 'radio'}
                                        name="dias"
                                        id={`dia-${dia}`}
                                        checked={diasSeleccionados.includes(dia)}
                                        onChange={() => toggleDia(dia)}
                                    />
                                ))
                            )}
                        </div>
                    </Card>
                </Col>

                <Col md={6}>
                    <Card body>
                        <Form.Group controlId="horaEnvio">
                            <Form.Label>Horario</Form.Label>
                            <Form.Control
                                type="time"
                                value={horaEnvio}
                                onChange={(e) => setHoraEnvio(e.target.value)}
                            />
                        </Form.Group>
                    </Card>
                </Col>
            </Row>

            <div className="mt-4 d-flex justify-content-end">
                <Button onClick={() => setPaso(2)}>Continuar</Button>
            </div>
        </>
    );

    // Paso 2

    const renderPaso2 = () => (
        <>
            <h5 className='section-subtitle'>¿Qué te gustaría analizar?</h5>
            <p className='section-description'>Aquí puedes definir el tipo de análisis que deseas recibir.</p>

            <Form.Group className="mb-4" controlId="nombreReporte">
                <Form.Label><strong>Nombre del informe</strong></Form.Label>
                <Form.Control
                    type="text"
                    placeholder="Escribe el nombre de tu informe"
                    value={nombreReporte}
                    onChange={(e) => setNombreReporte(e.target.value)}
                />
            </Form.Group>

            <Form.Group className="mb-4" controlId="instrucciones">
                <Form.Label><strong>Instrucciones para el análisis</strong></Form.Label>
                <Form.Control
                    as="textarea"
                    rows={4}
                    placeholder="Describe con detalle qué tipo de informe te gustaría recibir"
                    value={instrucciones}
                    onChange={(e) => setInstrucciones(e.target.value)}
                />
            </Form.Group>

            <Button variant="outline-primary" className="mb-3">
                + Añadir análisis
            </Button>

            <div className="mt-4 d-flex justify-content-between">
                <Button variant="link" onClick={() => setPaso(1)}>Regresar</Button>
                <Button variant="primary" onClick={handleCrearReporte}>Crear reporte</Button>
            </div>
        </>
    );
    const handleCrearReporte = async () => {
        const token = localStorage.getItem("token"); 
      
        const payload = {
          instruccion: instrucciones,
          schema: "kia_miami_schema" // opcional si ya lo tienes desde el backend
        };
      
        try {
          const response = await fetch("http://localhost:8000/informe/", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
          });
      
          const data = await response.json();
      
          console.log("✅ RESPUESTA DEL BACKEND:", data); // 🎯 aquí ves el análisis, SQL, etc.
      
          if (!response.ok) {
            throw new Error(data.error || "Error generando informe");
          }
      
          // Puedes seguir con el flujo normal si quieres
          const nuevo = {
            nombre: nombreReporte || "Nuevo informe",
            fecha: new Date().toLocaleDateString("es-PE"),
            periodicidad: frecuencia,
          };
      
          onVolver(nuevo);
      
        } catch (error) {
          console.error("Error creando reporte:", error);
        }
      };
      



    return (
        <Card className="card-asistente-ia">
            <div className="header-section d-flex justify-content-between align-items-center">
                <h3 className="title">Asistente IA</h3>
                <Button variant="outline-secondary" onClick={onVolver}>Cancelar</Button>
            </div>
            {/* Encabezado de pasos */}
            <div className="wizard-header mb-4 d-flex align-items-center gap-2">
                <div className={`step-circle ${paso > 1 ? 'completed' : 'active'}`}>
                    {paso > 1 ? <RiCheckLine size={16} /> : '1'}
                </div>
                <span className={`step-label ${paso === 1 ? 'active' : ''}`}>Configuración de envío</span>

                <div className="step-line" />

                <div className={`step-circle ${paso === 2 ? 'active' : ''}`}>
                    2
                </div>
                <span className={`step-label ${paso === 2 ? 'active' : ''}`}>¿Qué te gustaría analizar?</span>
            </div>


            <div className="content-section">
                {paso === 1 ? renderPaso1() : renderPaso2()}
            </div>
            

        </Card>
        
    );
};

export default NuevoReporte;
